import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'showRedeemedCoupons',
  initialState: false,
  reducers: {
    setShowRedeemedCoupons(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setShowRedeemedCoupons } = slice.actions;

export default slice.reducer;
